module.exports = __webpack_public_path__ + "img/stroke_weight.ebf21a0f.svg";